export const DEFAULT_WINDOW_WIDTH = "900";
export const DEFAULT_WINDOW_HEIGHT = "1350";
export const BOTTOM_BAR_OFFSET = 40;
export const SHUTTERS_CATEGORY_ID = 3;
